module.exports = __webpack_public_path__ + "static/media/closeIcon.2f3e8d78.svg";